// extracted by mini-css-extract-plugin
export default {"SearchTabs":"SearchTabs9v4kr3U2lwvI","SearchTabs-Tab":"SearchTabs-Tab2715KRxrb5JT","SearchTabs-Tab-Count":"SearchTabs-Tab-Count2n18wnK_m2fP"};